import reduxLib from '../redux';
const {loadingModal} = reduxLib.loading.actions;
const {openModal} = reduxLib.modal.actions;
const {openMsg} = reduxLib.msg.actions;
const {openOverlay} = reduxLib.overlay.actions;
const {openSidebar} = reduxLib.sidebar.actions;

function useOpenModalStore(dispatch) {
   function setIsloadingModal(loading) {
      dispatch(loadingModal(loading));
   }
   function openMsgModal(msg) {
      dispatch(openMsg(msg));
   }
   function openModalComponent(
      Component,
      componentProps = {},
      callbackOnClose = null,
      containerProps = {}
   ) {
      dispatch(openModal(Component, componentProps, callbackOnClose, containerProps));
   }

   function openSidebarComponent(
      Component,
      componentProps = {},
      callbackOnClose = null,
      containerProps = {}
   ) {
      dispatch(openSidebar(Component, componentProps, callbackOnClose, containerProps));
   }

   function openOverlayComponent(
      Component,
      componentProps = {},
      callbackOnClose = null,
      containerProps = {}
   ) {
      dispatch(openOverlay(Component, componentProps, callbackOnClose, containerProps));
   }

   return {
      setIsloadingModal,
      openMsgModal,
      openModalComponent,
      openSidebarComponent,
      openOverlayComponent
   };
}

export default useOpenModalStore;
